<template>
  <div class="bindPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @addFn="addFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @dataImFn="dataImFn"
        v-on="$listeners"
        @ruleFn="ruleFn"
        @netFn="netFn"
      />
      <!-- @tableTelFn="tableTelFn" -->
      <div class="componentPage">
        <unKnowTable
          v-bind="$attrs"
          :loading="loading"
          :shiquArray="shiquArray"
          :tableData="tableData"
          @choozeTable="choozeTable"
          @editFn="editFn"
          @delRowFn="delRowFn"
          @detailFn="detailFn"
          @configFn="configFn"
          @stopAlarmFn="stopAlarmFn"
        />
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
    <!-- 新增&&编辑 -->
    <AddEdit
      :isShow.sync="isShow"
      :title="title"
      :scopeArray="scopeArray"
      :shiquArray="shiquArray"
      :editRow="editRow"
      ref="vForm"
      v-bind="$attrs"
    />
    <!-- 详情 -->
    <detailDialog :isDetailShow.sync="isDetailShow" v-bind="$attrs" />
    <!-- 上报规则 -->
    <ruleDialog
      :isShow.sync="isRuleShow"
      ref="rule"
      :choozeTableData="choozeTableData"
    />
    <!-- 网络参数 -->
    <netDialog
      :isShowNet.sync="isShowNet"
      ref="net"
      :choozeTableData="choozeTableData"
    />
    <!-- 配置 -->
    <configDialog
      :isShowConfig.sync="isShowConfig"
      :rowData="rowData"
      :title="title"
      v-bind="$attrs"
      ref="config"
      v-if="isShowConfig"
    />
    <!-- 上传 -->
    <importDialog :isShowImDialog.sync="isShowImDialog" ref="importDia" />
  </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'

import unKnowTable from './unKnowTable.vue'
import EditScope from '../components/EditScope.vue'
import AddEdit from '../components/AddEditDialog.vue'
import detailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import ruleDialog from '../components/ruleDialog.vue'
import netDialog from '../components/netDialog.vue'
import configDialog from '../components/ConfigDialog.vue'
import importDialog from '../components/DispalyIm.vue'

import {
  contentList,
  displayDel,
  displayGetDisplayDetailInfo,
  displayList,
  displayUpdateAppConfig
} from '@/api/modules/display.js'

import { shareScope } from '@/api/modules/public.js'
import { getIsPlatform } from '@/utils/permission'

export default {
  mixins: [getAllTreePath],
  components: {
    unKnowTable,
    EditScope,
    AddEdit,
    detailDialog,
    ruleDialog,
    netDialog,
    configDialog,
    importDialog
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'device.display_name',
          type: 'input',
          paramsName: 'name',
          isChooze: true
        },
        {
          id: 6,
          text: 'device.display_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 4,
          text: 'device.display_number',
          type: 'input',
          paramsName: 'terminalCode',
          isChooze: false
        }
      ],
      SearchForm: {
        name: null,
        scopeName: null,
        terminalCode: null,
        type: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 3,
        //   icon: '',
        //   vHas: ['incubatorAddCarrier'],
        //   text: 'public.escalation_rules',
        //   method: 'ruleFn'
        // },
        // {
        //   id: 4,
        //   icon: '',
        //   vHas: ['incubatorAddCarrier'],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        {
          id: 6,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.import_data',
          method: 'dataImFn'
        },
        {
          id: 7,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.modify_customer',
          method: 'editScopeFn'
        }
      ],
      // shiquArray: [],
      isShow: false,
      choozeTableData: [],
      // 修改范围
      isShowEditShow: false,
      scopeArray: [],
      editRow: {},
      // 详情
      shiquArray: [],
      isDetailShow: false,
      detailObj: {},
      // 配置
      isRuleShow: false,
      isShowNet: false,
      rowData: {},
      isShowConfig: false,
      // 上传
      isShowImDialog: false,
      detailNetObj: {},
      deviceType: {},
      deviceProperty: {}
    }
  },
  created () {
    this.contentListFn()
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 获取范围 */
    getSence () {
      if (this.scopeArray.length > 0) return
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    /** 时区 */
    contentListFn () {
      if (this.shiquArray.length > 0) return
      contentList({
        code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE',
        type: 0
      }).then(({ result }) => {
        this.shiquArray = result
      })
    },
    /** 分页 */
    getListFn () {
      this.loading = true
      displayList(this.SearchForm, 'unknown')
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        code: null,
        scopeName: null,
        type: '',
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 暂停报警 */
    stopAlarmFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(res => {
          displayUpdateAppConfig({
            idList: [row.id],
            alarmOn: 0
          }).then(({ result, state }) => {
            if (result && state.code === 200) {
              this.$message.success($t('integration.success'))
              this.getListFn()
            }
          })
        })
        .catch(() => {})
    },
    /** 新增 */
    addFn () {
      this.isShow = true
      this.title = $t('integration.new_display')
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        this.$refs.vForm.dioForm.id = null
      })
    },
    /** 编辑 */
    editFn (row) {
      this.isShow = true
      this.title = `编辑${row.name}显示屏`
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
      })
      displayGetDisplayDetailInfo(row.id).then(({ result }) => {
        this.editRow = Object.assign(
          {},
          { ...result.appConfig },
          { ...result.netConfig },
          { ...result.display }
        )
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_sensor_is_not_the_same_customer')
        )
      }
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].sceneId + ''
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 2
          }

          displayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = {
            ids: row.id,
            edited: 2
          }
          displayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 上报规则 */
    ruleFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isRuleShow = true

      this.$nextTick(() => {
        this.$refs.rule.clearValidate()
      })
    },
    /** 网络参数 */
    netFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShowNet = true
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 表格模板 */
    // tableTelFn() {
    //     this.$emit('loadFileFn')
    // },
    // 数据导入
    dataImFn () {
      this.isShowImDialog = true
      this.$nextTick(() => {
        if (this.$refs.importDia.$refs.refFile) {
          this.$refs.importDia.$refs.refFile.clearFiles()
        }
      })
    },
    /** 配置 */
    configFn (row) {
      this.rowData = { ...row }
      this.isShowConfig = true
      this.title = $t('integration.configuration_information')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigRule'
      })
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('displayParam', row.id, row.name, row.scopeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  width: 100%;
  height: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
